import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Table, Input, Dropdown, Menu, Button, Select } from 'antd';
import { DownOutlined, SearchOutlined } from '@ant-design/icons';
import { PDFDocument } from 'pdf-lib';
import NavbarPicking from '../../picking/components/navbarPicking/navbarPicking';
import './shopifyOrdenes.css';

const { Option } = Select;

const ShopifyOrdenesOrigen4 = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [filters, setFilters] = useState({
    estadoOrden: '',
    transportadora: '',
    estadoEnvio: '',
  });
  const [selectedItems, setSelectedItems] = useState([]);
  const [expandedKeys, setExpandedKeys] = useState([]);
  const usuario_id = localStorage.getItem('usuario_id');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`https://api.99envios.app/api/listar_ordenes/${usuario_id}`);
        const filteredData = response.data.filter(item => item.origen_creacion === 4);
        const formattedData = filteredData.map((item, index) => ({
          key: index,
          id: index + 1,
          nombre_producto: item.nombre_producto,
          fecha_estado: item.preeenvio?.fecha_estado || 'No disponible',
          estado_envio: item.preeenvio?.estado?.nombre || 'No disponible',
          transportadora: item.preeenvio?.transportadora?.nombre || 'No disponible',
          valor_proveedor: item.valor_proveedor,
          valor_total: item.valor_venta,
          valor_utilidad: item.valor_utilidad,
          numero_guia: item.preeenvio.numero_preenvio,
          nombre_destinatario: `${item.preeenvio.destinatario.nombre} ${item.preeenvio.destinatario.primer_apellido}`,
          telefono_destinatario: item.preeenvio.destinatario.telefono,
          direccion_destinatario: item.preeenvio.destinatario.direccion,
          bodega: {
            nombre: item.bodega?.nombre_sucursal || 'No asignada',
            ciudad: item.bodega?.ciudad?.ciudad || 'No especificada'
          },
          fecha_creacion: item.preeenvio.fecha_creacion,
          fecha_vencimiento: item.preeenvio.fecha_vencimiento,
          peso: item.preeenvio.peso,
          largo: item.preeenvio.largo,
          ancho: item.preeenvio.ancho,
          alto: item.preeenvio.alto,
          valor_declarado: item.preeenvio.valor_declarado,
          valor_comercial: item.preeenvio.valor_comercial,
          observaciones: item.preeenvio.observaciones,
          selected: false,
        }));
        setData(formattedData);
        setFilteredData(formattedData);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, [usuario_id]);

  const columns = [
    {
      title: '#',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'Nombre del producto',
      dataIndex: 'nombre_producto',
      key: 'nombre_producto',
    },
    {
      title: 'Variación',
      dataIndex: 'variacion',
      key: 'variacion',
      render: (_, record) => {
        const idVariacion = record.id_variacion ? `ID: ${record.id_variacion}` : 'Sin variación';
        const talla = record.talla ? `Talla: ${record.talla}` : 'Sin talla';
        const color = record.color ? `Color: ${record.color}` : 'Sin color';

        return (
          <div>
            <p>{idVariacion}</p>
            <p>{talla}</p>
            <p>{color}</p>
          </div>
        );
      },
    },
    {
      title: 'Bodega',
      dataIndex: 'bodega',
      key: 'bodega',
      render: (bodega) => (
        <div>
          <p>{bodega.nombre}</p>
          <p>{bodega.ciudad}</p>
        </div>
      ),
    },
    {
      title: 'Fecha de estado',
      dataIndex: 'fecha_estado',
      key: 'fecha_estado',
    },
    {
      title: 'Estado del Envío',
      dataIndex: 'estado_envio',
      key: 'estado_envio',
    },
    {
      title: 'Transportadora',
      dataIndex: 'transportadora',
      key: 'transportadora',
    },
    {
      title: 'Valor de Proveedor',
      dataIndex: 'valor_proveedor',
      key: 'valor_proveedor',
      render: (value) => `$${value.toLocaleString()}`,
    },
    {
      title: 'Valor Total',
      dataIndex: 'valor_total',
      key: 'valor_total',
      render: (value) => `$${value.toLocaleString()}`,
    },
    {
      title: 'Utilidad',
      dataIndex: 'valor_utilidad',
      key: 'valor_utilidad',
      render: (value) => `$${value.toLocaleString()}`,
    },
    {
      title: 'Numero de Guía',
      dataIndex: 'numero_guia',
      key: 'numero_guia',
      render: (value) => value || 'Sin guía',
    },
    {
      title: 'Destinatario',
      dataIndex: 'nombre_destinatario',
      key: 'nombre_destinatario',
    },
    {
      title: 'Teléfono',
      dataIndex: 'telefono_destinatario',
      key: 'telefono_destinatario',
    },
    {
      title: 'Dirección',
      dataIndex: 'direccion_destinatario',
      key: 'direccion_destinatario',
    },
    {
      title: 'Fecha de Creación',
      dataIndex: 'fecha_creacion',
      key: 'fecha_creacion',
    },
    {
      title: 'Fecha de Vencimiento',
      dataIndex: 'fecha_vencimiento',
      key: 'fecha_vencimiento',
    },
    {
      title: 'Peso',
      dataIndex: 'peso',
      key: 'peso',
    },
    {
      title: 'Largo',
      dataIndex: 'largo',
      key: 'largo',
    },
    {
      title: 'Ancho',
      dataIndex: 'ancho',
      key: 'ancho',
    },
    {
      title: 'Alto',
      dataIndex: 'alto',
      key: 'alto',
    },
    {
      title: 'Valor Declarado',
      dataIndex: 'valor_declarado',
      key: 'valor_declarado',
      render: (value) => `$${value.toLocaleString()}`,
    },
    {
      title: 'Valor Comercial',
      dataIndex: 'valor_comercial',
      key: 'valor_comercial',
      render: (value) => `$${value.toLocaleString()}`,
    },
    {
      title: 'Observaciones',
      dataIndex: 'observaciones',
      key: 'observaciones',
      render: (text, record) => {
        const isExpanded = expandedKeys.includes(record.key);
        const displayText = isExpanded ? text : text.slice(0, 50) + (text.length > 50 ? '...' : '');
        return (
          <div>
            <p>{displayText}</p>
            {text.length > 50 && (
              <Button type="link" onClick={() => handleExpandClick(record.key)}>
                {isExpanded ? 'Mostrar menos' : 'Mostrar más'}
              </Button>
            )}
          </div>
        );
      },
    },
  ];

  const handleExpandClick = (key) => {
    setExpandedKeys((prevKeys) =>
      prevKeys.includes(key) ? prevKeys.filter((k) => k !== key) : [...prevKeys, key]
    );
  };

  const handleSearch = (value) => {
    setSearchText(value);
    const filtered = data.filter(
      (item) =>
        item.nombre_producto.toLowerCase().includes(value.toLowerCase()) ||
        item.bodega.nombre.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredData(filtered);
  };

  const handleFilterChange = (filterName, value) => {
    setFilters({ ...filters, [filterName]: value });
  };

  useEffect(() => {
    let result = data;
    if (searchText) {
      result = result.filter(
        (item) =>
          item.nombre_producto.toLowerCase().includes(searchText.toLowerCase()) ||
          item.bodega.nombre.toLowerCase().includes(searchText.toLowerCase())
      );
    }
    if (filters.transportadora) {
      result = result.filter((item) => item.transportadora.toLowerCase() === filters.transportadora.toLowerCase());
    }
    if (filters.estadoEnvio) {
      result = result.filter((item) => item.estado_envio.toLowerCase() === filters.estadoEnvio.toLowerCase());
    }
    setFilteredData(result);
  }, [searchText, filters, data]);

  return (
    <>
      <NavbarPicking title="Órdenes Origen 4" />
      <div className='shopify-misPedidos'>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '16px' }}>
          <Input
            placeholder="Buscar por producto o bodega"
            prefix={<SearchOutlined />}
            style={{ width: 200 }}
            onChange={(e) => handleSearch(e.target.value)}
          />
        </div>
        <div style={{ marginBottom: '16px' }}>
          <Select
            style={{ width: 200, marginRight: '8px' }}
            placeholder="Filtrar por Transportadora"
            onChange={(value) => handleFilterChange('transportadora', value)}
          >
            <Option value="">Todas</Option>
            <Option value="interrapidisimo">Interrapidisimo</Option>
            <Option value="coordinadora">Coordinadora</Option>
            <Option value="servientrega">Servientrega</Option>
            <Option value="envia">Envia</Option>
          </Select>
          <Select
            style={{ width: 200 }}
            placeholder="Filtrar por Estado de Envío"
            onChange={(value) => handleFilterChange('estadoEnvio', value)}
          >
            <Option value="">Todos</Option>
            <Option value="creado">Creado</Option>
            <Option value="error">Error</Option>
            <Option value="en_transito">En tránsito</Option>
            <Option value="entregado">Entregado</Option>
          </Select>
        </div>
        <div className="shopify-misPedidos-tabla" style={{ overflowX: 'auto' }}>
          <Table
            columns={columns}
            dataSource={filteredData}
            pagination={{
              pageSize: 10,
              showSizeChanger: false,
              showQuickJumper: false,
            }}
            scroll={{ x: 1500 }}
            locale={{ emptyText: 'No hay datos disponibles' }}
          />
        </div>
      </div>
    </>
  );
};

export default ShopifyOrdenesOrigen4;